import {customElement} from '@aofl/element';
import {sdoNs} from '../constants-enumerate';
import {BaseSearchOrgFilters} from '../base-search-org-filters';

/**
 * @summary UserSearchOrgFilters
 * @extends {BaseSearchOrgFilters}
 */
@customElement('user-search-org-filters')
class UserSearchOrgFilters extends BaseSearchOrgFilters {
  static is = 'user-search-org-filters';

  filterUpdated(e) {
    this.selectedGroups = e.target['selected-groups'];
    this.storeInstance.commit(
      {
        namespace: sdoNs.USER_SEARCH,
        mutationId: 'setFiltersGroupPath',
        payload: this.selectedGroups
      },
      {
        namespace: sdoNs.USER_SEARCH,
        mutationId: 'setPendingFiltersGroupPath',
        payload: this.selectedGroups
      }
    );
    this.dispatchEvent(new CustomEvent('changed'));
  }

  mapStateProperties() {
    super.mapStateProperties();
    const state = this.storeInstance.getState();

    this.selectedGroups = state[sdoNs.USER_SEARCH].pendingFilters.group_path;
  }


  /**
   * @readonly
   */
}

export default UserSearchOrgFilters;
